// For a search page whose every load replaces its lists (BSD-39271). A reply belongs on screen only while it comes
// from the newest load of its list and, on a page with tabs, that list's tab is the one showing: a tab switch, or an
// action reloading the other tab, mustn't put that tab's records or count on this one.
//
// shownTab reads the tab showing from the state; leave it out on a page without tabs. The counters are per store,
// so call it once per page module (each page has one store).
export default function latestLoad(shownTab) {
  const newest = {};

  return function startLoad(list, getState) {
    newest[list] = (newest[list] || 0) + 1;
    const generation = newest[list];
    const showing = () => !shownTab || shownTab(getState()) === list;

    return {
      // Whether the list is on screen, so the page shows it loading.
      showing,
      // Whether the reply may land: nothing newer has loaded this list, and it is still on screen.
      current: () => generation === newest[list] && showing(),
    };
  };
}
